<div class="full-page" fxLayout="row">
    <div class="app-sidebar">
        <div fxLayout="row" fxLayoutAlign="start center" class="branding" routerLink="/sitemap" style="padding:10px">
            <img src="assets/images/process.png" style="width:75%;margin:0px auto" fxShow.gt-md="true" fxHide />
            <label style="color:wheat;font-size:10px;">v{{version}}</label>
            <!--
            <div fxLayout="column" style="margin-left:10px;">
                <div class="app-title" fxLayout="row" fxLayoutAlign="start center">
                    <div>Echol Tech
                        <small style="color:wheat;font-size:9px;margin-left:5px;">v{{version}}</small>
                    </div>
                </div>
                <div class="app-subTitle">eProducer

                </div>
            </div>
        -->
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="loginStatus" *ngIf="user">
            <avatar [name]="user.Name" [size]="34"></avatar>
            <span style="padding:0 10px;font-size:13px;" fxFlex>
                {{user.Name}}
            </span>
            <button mat-icon-button style="font-size:1.3em" [matMenuTriggerFor]="appMenu">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <kendo-panelbar expandMode="single">
            <kendo-panelbar-item title="Staff Management" *accessRights="['STAFF_DESIGNATION', 'STAFF_DEPARTMENT', 'STAFF_MANAGEMENT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li><a routerLink="/staff/list" *accessRights="['STAFF_MANAGEMENT']">Staff List</a></li>
                        <li><a routerLink="/staff/designation/list" *accessRights="['STAFF_DESIGNATION']">Designation</a></li>
                        <li><a routerLink="/staff/department/list" *accessRights="['STAFF_DEPARTMENT']">Department</a></li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="{{companyString}} Management" *accessRights="['COMPANY_MANAGEMENT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li>
                            <a routerLink="/company" *accessRights="['COMPANY_MANAGEMENT']">{{companyString}}</a>
                        </li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="{{assetString}} Management" *accessRights="['ASSET_MANAGEMENT','ASSET_TYPE','ASSET_GROUP','ASSET_IMPORT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li><a routerLink="/asset/list" *accessRights="['ASSET_MANAGEMENT']">{{assetString}} List</a></li>
                        <li><a routerLink="/asset/import" *accessRights="['ASSET_IMPORT']">Bulk Import</a></li>
                        <li><a routerLink="/asset/type/list" *accessRights="['ASSET_TYPE']">{{assetString}} Type</a></li>
                        <li><a routerLink="/asset/group/list" *accessRights="['ASSET_GROUP']">{{assetString}} Group</a></li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Action Management" *accessRights="['ACTION_MANAGEMENT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li>
                            <a routerLink="/action/list" *accessRights="['ACTION_MANAGEMENT']">Action List</a>
                        </li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Process Management" *accessRights="['PROCESS_MANAGEMENT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li>
                            <a routerLink="/process/list" *accessRights="['PROCESS_MANAGEMENT']">Process List</a>
                        </li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Work Order Management" *accessRights="['WORKORDER_MANAGEMENT','GUIDED_INSPECTION']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li>
                            <a routerLink="/workorder/list">Work Order List</a>
                        </li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Reports"
                *accessRights="['REPORT_LIVE_TRANSACTION', 'REPORT_LIVE_TRANSACTION_SINGLE', 'REPORT_HIST_TRANSACTION', 'REPORT_HIST_TRANSACTION_SINGLE', 'REPORT_OVERALL_STATUS', 
                                'REPORT_DEMO_SUBCON_OVERALL_SUMMARY', 'REPORT_DEMO_SUBCON_DAILY_PRODUCTION','REPORT_DEMO_MAINCON_OVERALL_SUMMARY','REPORT_DEMO_MAINCON_SEGMENT_TRACKING',
                                'REPORT_CONTECH_OVERALL_SUMMARY', 'REPORT_POKB_OVERALL_SUMMARY', 'REPORT_POKB_SEGMENT_TRACKING', 'REPORT_DAILY_PRODUCTION','REPORT_RBV_OVERALL_STATUS']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li><a routerLink="/report/livetransaction" *accessRights="['REPORT_LIVE_TRANSACTION']">Live Transaction</a></li>
                        <li><a routerLink="/report/livetransactionS" *accessRights="['REPORT_LIVE_TRANSACTION_SINGLE']">Live Transaction</a></li>
                        <li><a routerLink="/report/historicaltransaction" *accessRights="['REPORT_HIST_TRANSACTION']">Historical Transaction</a></li>
                        <li><a routerLink="/report/historicaltransactionS" *accessRights="['REPORT_HIST_TRANSACTION_SINGLE']">Historical Transaction</a></li>
                        <li><a routerLink="/report/overallstatussummary" *accessRights="['REPORT_OVERALL_STATUS']">Overall Status Summary</a></li>
                        <!--demo-->
                        <li><a routerLink="/report/subconoverallsummary" *accessRights="['REPORT_DEMO_SUBCON_OVERALL_SUMMARY']">Subcon Overall Summary</a></li>
                        <li><a routerLink="/report/subcondailyproduction" *accessRights="['REPORT_DEMO_SUBCON_DAILY_PRODUCTION']">Subcon Daily Production</a></li>
                        <li><a routerLink="/report/mainconoverallsummary" *accessRights="['REPORT_DEMO_MAINCON_OVERALL_SUMMARY']">Maincon Overall Summary</a></li>
                        <li><a routerLink="/report/mainconsegmenttracking" *accessRights="['REPORT_DEMO_MAINCON_SEGMENT_TRACKING']">Maincon Segment Tracking</a></li>
                        <!--T08-->
                        <li><a routerLink="/report/contechoverallsummary" *accessRights="['REPORT_CONTECH_OVERALL_SUMMARY']">Contech Overall Summary</a></li>
                        <li><a routerLink="/report/pokboverallsummary" *accessRights="['REPORT_POKB_OVERALL_SUMMARY']">POKB Overall Summary</a></li>
                        <li><a routerLink="/report/pokbsegmenttracking" *accessRights="['REPORT_POKB_SEGMENT_TRACKING']">POKB Segment Tracking</a></li>
                        <li><a routerLink="/report/dailyproduction" *accessRights="['REPORT_DAILY_PRODUCTION']">Daily Production</a></li>
                        <!-- RBV-->
                        <li><a routerLink="/report/rbvoverallstatussummary" *accessRights="['REPORT_RBV_OVERALL_STATUS']">RBV Overall Status Summary</a></li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Administrative" *accessRights="['ADMINISTRATIVE_PROFILE','ADMINISTRATIVE_AUDIT_LOG', 'ADMINISTRATIVE_ACCOUNT']">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li><a routerLink="/administrative/account/list" *accessRights="['ADMINISTRATIVE_ACCOUNT']">Account</a></li>
                        <li><a routerLink="/administrative/auditlog" *accessRights="['ADMINISTRATIVE_AUDIT_LOG']">Audit Log Report</a></li>
                        <li><a routerLink="/administrative/profile/list" *accessRights="['ADMINISTRATIVE_PROFILE']">Profile</a></li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Download Guides">
                <ng-template kendoPanelBarContent>
                    <ul class="menu">
                        <li>
                            <a routerLink="/guidebook/list">List</a>
                        </li>
                    </ul>
                </ng-template>
            </kendo-panelbar-item>
        </kendo-panelbar>
    </div>
    <div class="app-content">
        <!--<ng2-toasty position="top-center"></ng2-toasty>-->
        <div class="page" fxLayout="column">
            <div class="page-header" fxLayout="row" fxFlex="0 0 auto" fxLayoutAlign="start center">
                <div style="max-width: 300px" *ngIf="auth.Title | async; let title;">
                    <div class="title">{{title.Title}}</div>
                    <span>{{title.SubTitle}}</span>
                </div>
                <div fxFlex="1 0 auto" style="padding-right:20px;" fxLayout="row" fxLayoutAlign="end center" fxShow="true" fxShow.lt-md="false">
                    <img src="assets/images/logo.png" height="60px" />
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>
    </div>
    <mat-menu #appMenu="matMenu">
        <button mat-menu-item *ngIf="isSysAdmin" routerLink="/sysadmin/site/list">Switch Site</button>
        <button mat-menu-item (click)="changePassword()">Change Password</button>
        <button mat-menu-item (click)="signout()">Logout</button>
    </mat-menu>
</div>